import { InvoiceSearchCriteria } from "./InvoiceSearchCriteria";

export interface BuyerInvoiceSearchCriteria extends InvoiceSearchCriteria{
  locationId?: string,
  transactionType?: string,
  buyerTransactionStatus?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const BUYER_INVOICES_DATE_BYPASS_KEYS: readonly (keyof BuyerInvoiceSearchCriteria)[] = ['orderNumber', 'transactionNumber'];
